export default __webpack_public_path__ + "static/media/partner_logo_elhub.5889858d.svg";